'use strict';

// show the arrow below the top 5 pro list
$('#report-priorities .show-more-task a').on('click', function (event) {
  event.preventDefault();
  $('#report-priorities .show-more-task i').toggleClass('hidden');
  return $(this).off('click');
});
